import React, { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";

import "./TagTab.scss";
import { confirm } from "devextreme/ui/dialog";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { createTag, deleteTag, getTag, updateTag } from "../../../api/tagApi";
export default function TagTab() {
  const [loading, setLoading] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [tagInput, setTagInput] = useState("");

  // Edit mode state
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  // ── FETCH TAGS ──────────────────────────────────
  const fetchTags = async () => {
    try {
      setLoading(true);

      const res = await getTag();

      if (res.success) {
        setTagList(res.data?.data || res.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch tags.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  // ── ADD TAG ──────────────────────────────────
  const handleAddTag = async () => {
    if (!tagInput.trim()) {
      ToastDisplayer("error", "Please enter a tag name.");
      return;
    }

    try {
      setLoading(true);

      const res = await createTag({
        tagname: tagInput,
      });

      if (res.success) {
        ToastDisplayer("success", "Tag added successfully!");
        setTagInput("");
        fetchTags();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to add tag.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ── START editing a row ─────────────────────────────────────────────────
  const handleEditClick = (item) => {
    setEditingId(item.tagid);
    setEditingValue(item.tagname);
  };

  // ── SAVE edited Tag ──────────────────────────────────────────────────
  const handleEditSave = async (id) => {
    if (!editingValue.trim()) {
      ToastDisplayer("error", "Tag name cannot be empty.");
      return;
    }

    try {
      setLoading(true);

      const res = await updateTag(id, {
        tagname: editingValue,
      });

      if (res.success) {
        ToastDisplayer("success", "Tag updated successfully!");
        setEditingId(null);
        setEditingValue("");
        fetchTags();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to update tag.",
      );
    } finally {
      setLoading(false);
    }
  };
  // ── CANCEL editing ──────────────────────────────────────────────────────
  const handleEditCancel = () => {
    setEditingId(null);
    setEditingValue("");
  };

  // ── DELETE TAG ──────────────────────────────────
  const handleDelete = async (id) => {
    confirm("Are you sure you want to delete this record?").then(
      async (result) => {
        if (!result) return;

        try {
          setLoading(true);

          const res = await deleteTag(id);

          if (res.success) {
            ToastDisplayer("success", "Tag deleted successfully!");
            fetchTags();
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error?.response?.data?.message || "Failed to delete tag.",
          );
        } finally {
          setLoading(false);
        }
      },
    );
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="tagTabSec">
        <div className="tagTabCard">
          <div className="tagCardHead">
            <span className="tagCardTitle">Manage Tags</span>
          </div>

          <div className="tagCardBody">
            <div className="catInputRow">
              <div className="catInputWrap">
                <label className="catLabel">
                  Tag Name <span className="required">*</span>
                </label>

                <input
                  className="catTextBox"
                  placeholder="Enter Tag Name"
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleAddTag()}
                />
              </div>

              <button className="catAddBtn" onClick={handleAddTag}>
                Add Tag
              </button>
            </div>

            {/* LIST */}
            <div className="catListWrap" style={{height: "calc(100vh - 455px)" }}>
              <div className="catListHeader">
                <span>Tag Name</span>
              </div>

              {tagList.length === 0 && !loading && (
                <div className="catEmptyMsg">No Tags found.</div>
              )}

              {tagList.map((item) => (
                <div className="catListRow" key={item.tagid}>
                  {editingId === item.tagid ? (
                    <div className="catEditRow">
                      <input
                        className="catTextBox"
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleEditSave(item.tagid);
                          if (e.key === "Escape") handleEditCancel();
                        }}
                        autoFocus
                      />

                      <button
                        className="catSaveBtn"
                        onClick={() => handleEditSave(item.tagid)}
                      >
                        ✓
                      </button>

                      <button
                        className="catCancelBtn"
                        onClick={handleEditCancel}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="catRowText">{item.tagname}</span>

                      <div className="catRowActions">
                        <button
                          className="catIconBtn editIcon"
                          title="Edit"
                          onClick={() => handleEditClick(item)}
                        >
                          <i className="ri-pencil-line" />
                        </button>

                        <button
                          className="catIconBtn deleteIcon"
                          title="Delete"
                          onClick={() => handleDelete(item.tagid)}
                        >
                          <i className="ri-delete-bin-line" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
